import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "On the Roblox Platform",
          "A Moderation System",
          "Ran by Mountain Interactive LLC",
          "Scripted by Ash and Leo",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
